/**
 * Runs `fn` over `items` with at most `limit` calls in flight, draining in
 * sequential chunks, and never rejects — each item's outcome is reported in
 * order. Use instead of an unbounded `Promise.all(items.map(callable))`, which
 * saturates the browser connection pool and burst-scales the backend.
 */
export const mapWithConcurrencySettled = async <T, R>(
  items: T[],
  limit: number,
  fn: (item: T) => Promise<R>
): Promise<PromiseSettledResult<R>[]> => {
  const results: PromiseSettledResult<R>[] = [];
  for (let i = 0; i < items.length; i += limit) {
    results.push(
      ...(await Promise.allSettled(items.slice(i, i + limit).map(fn)))
    );
  }
  return results;
};
